import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList } from "./response";

export const approvalsApi = {
  async list() {
    const response = await apiClient.get("/approvals");
    return unwrapList(response.data);
  },

  async approve(entityType, entityId, payload = {}) {
    const response = await apiClient.post(`/approvals/${entityType}/${entityId}/approve`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async reject(entityType, entityId, payload = {}) {
    const response = await apiClient.post(`/approvals/${entityType}/${entityId}/reject`, payload);
    return unwrapEnvelope(response.data, null);
  }
};
